import React, { useState, PureComponent } from "react";
// import PropTypes from 'prop-types';
import { connect } from "react-redux";

import { Button, ButtonToolbar, Modal, Row, Col } from "reactstrap";
import classNames from "classnames";
import Alert from "../../helper/Alert";

import { editCtg, getCtgs } from "../../../redux/actions/categoryActions";
import CtgsTree from "./ctgs-tree";
import { no_product_img, api } from "../../../const";

import { SketchPicker } from "react-color";

import Switch from "rc-switch";
import "rc-switch/assets/index.css";

const modalClass = classNames({
	"modal-dialog--colored": false,
	"modal-dialog--header": true,
});

class EditCtgMdl extends PureComponent {
	constructor() {
		super();
		this.state = {
			name: "",
			color: "",
			show_colors: false,
			img: null,
			img_url: "",
			parent: null,
			_id: "",
			is_internal: false,
      is_educational_support: false,

			error_editing: "",
		};
	}

	changeVal = (key, value) => {
		const obj = {};
		obj[key] = value;
		this.setState(obj);
	};

	submit = () => {
		const { name, img, img_url, parent, _id, color, is_internal, is_educational_support } = this.state;

		if (name != "") {
			const frm = new FormData();
			if (img && img_url != "") frm.append("img", img);
			if (parent && parent != "") frm.append("parent", parent);

			frm.append("name", name);
			frm.append("color", color);
			frm.append("is_internal", is_internal);
      frm.append("is_educational_support", is_educational_support);

			if (_id != "") this.props.editCtg({ _id, data: frm });
		}
	};
	checkFrm = (data) => {
		const { name } = data;
		if (name == "") return "Nom obligatoire.";
		return "";
	};

	componentWillMount() {
		const { ctg, getCtgs } = this.props;
		getCtgs();

		if (ctg) this.setState({ ...this.props.ctg });
	}

	componentDidUpdate(prev) {
		const { loading_edit_ctg, error_edit_ctg, new_ctg, ctg } = this.props;

		if (
			!prev.ctg ||
			(prev.ctg && ctg && (prev.ctg._id != ctg._id || prev.ctg.name != ctg.name || prev.ctg.parent != ctg.parent))
		) {
			this.setState({ ...ctg });
		}

		if (!loading_edit_ctg && prev.loading_edit_ctg) {
			if (error_edit_ctg) {
				if (error_edit_ctg.message && error_edit_ctg.message != "")
					this.setState({ error_frm: error_edit_ctg.message });
			} else this.props.handleSuccess();
		}
	}

	changeImg = (e) => {
		try {
			const img = e.target.files[0];
			this.setState({ img, img_url: URL.createObjectURL(img) });
		} catch (error) {
			this.setState({ img: null, img_url: "" });
		}
	};

	renderProductImage = (img, img_url) => {
		if (img && img_url == "") return <img src={api.root + "/" + img.path} />;
		else if (img && img_url != "") return <img src={img_url} />;

		return <img src={no_product_img} />;
	};

	render() {
		const { is_open, size, toggle, ctgs, getCtgs, ctg } = this.props;
		const { name, img, parent, img_url, color, is_internal, is_educational_support, show_colors } = this.state;

		return (
			<Modal
				isOpen={is_open}
				size={size || "lg"}
				toggle={toggle}
				// modalClassName={`${rtl.direction}-support`}
				className={`modal-dialog--primary ${modalClass}`}
			>
				<div className="modal__header">
					<h4 className="text-modal  modal__title">Modifier un categorie</h4>
				</div>
				<div className="modal__body" style={{ padding: "0 10px", textAlign: "left" }}>
					<Row className="form">
						<Col md="12" style={{ marginTop: 10, marginBottom: 10 }}>
							<Alert
								is_visible={this.state.error_editing != ""}
								color="danger"
								className="alert--colored"
								icon
							>
								<p>
									<span className="bold-text">Attention!</span> {this.state.error_editing}
								</p>
							</Alert>
						</Col>

						{/* <Col md="4">
              <div className="add_img_wrap">
                <img src={img_url == '' ? ` ${process.env.PUBLIC_URL}/img/no_product.png` : img_url } />

                <div className="caption">
                  <label htmlFor="add_avatar"><span className="lnr lnr-picture"></span></label>
                  <input onChange={(e)=>this.changeImg(e)} id="add_avatar" type="file" accept="image/*" hidden />
                </div>
              </div>
            </Col> */}
						<Col md="4">
							<div className="add_img_wrap">
								{this.renderProductImage(img, img_url)}

								<div className="caption">
									<label htmlFor="add_avatar">
										<span className="lnr lnr-picture"></span>
									</label>
									<input
										onChange={(e) => this.changeImg(e)}
										id="add_avatar"
										type="file"
										accept="image/*"
										hidden
									/>
								</div>
							</div>
						</Col>

						<Col md="8">
							<div className="form__form-group">
								<span className="form__form-group-label">Nom</span>
								<div className="form__form-group-field">
									<input
										style={{ width: "100%", border: "none", borderBottom: "1px solid #ddd" }}
										name="name"
										component="input"
										placeholder="Nom"
										value={name}
										onChange={(e) => this.changeVal("name", e.target.value)}
									/>
								</div>
							</div>

							<div className="mt-3 mb-3">
								<span style={{ marginRight: 8 }}>C'est un catégorie interne</span>
								<Switch
									className="custom-switch custom-switch-primary"
									checked={is_internal}
									onChange={(internal) => this.changeVal("is_internal", internal)}
								/>

								<span style={{ marginRight: 8, marginLeft: 8 }}>Support pédagogique</span>
								<Switch
									className="custom-switch custom-switch-primary"
									checked={is_educational_support}
									onChange={(educational_support) => this.changeVal("is_educational_support", educational_support)}
								/>
							</div>

							<div style={{ position: "relative", marginBottom: 20 }}>
								<span>Couleur</span>
								<div
									onClick={() =>
										this.setState((prev) => {
											return { show_colors: !prev.show_colors };
										})
									}
									style={{
										padding: 10,
										borderRadius: 4,
										backgroundColor: color,
										cursor: "pointer",
										border: "1px solid #9E9E9E",
										width: 50,
									}}
								></div>

								{show_colors && (
									<div style={{ position: "absolute", left: 55, top: 0, zIndex: 999 }}>
										{" "}
										<SketchPicker
											color={color || "#000"}
											onChangeComplete={(color) => this.changeVal("color", color.hex)}
										/>
									</div>
								)}
							</div>

							<CtgsTree
								getCtgs={() => getCtgs()}
								ctg={ctg}
								select_one={true}
								data={ctgs}
								checkCtg={(ctg_id) => this.setState({ parent: ctg_id })}
							/>
						</Col>
					</Row>

					<div>
						<ButtonToolbar className="modal__footer form__button-toolbar" style={{}}>
							<Button color="primary" onClick={this.submit}>
								Soumettre
							</Button>
							<Button type="button" onClick={this.props.toggle}>
								Annuler
							</Button>
						</ButtonToolbar>
					</div>
				</div>
			</Modal>
		);
	}
}

const mapStateToProps = ({ category }) => {
	return {
		// ctg: category.ctg,
		ctgs: category.ctgs,
		loading_edit_ctg: category.loading_edit_ctg,
		error_edit_ctg: category.error_edit_ctg,
		new_ctg: category.new_ctg,
	};
};
export default connect(mapStateToProps, {
	editCtg,
	getCtgs,
})(EditCtgMdl);
